import { takeEvery, take, put } from 'redux-saga/effects';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import { consts as commentsList } from './commentsList';

export const consts = createReqConsts('communities', 'editComment');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'posts',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['postId'],
    },
    'comments',
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

export default createReqReducer(consts);

function* editedCommentWorker(action) {
  const { id, content, parentId } = action.payload;
  yield put({
    type: commentsList.EDIT_COMMENT,
    payload: {
      id,
      content,
      parentId,
    },
  });
}

export function* editedCommentSaga() {
  yield takeEvery(consts.SEND, editedCommentWorker);
}



// WEBPACK FOOTER //
// ./src/redux/communities/editComment.js